
import Vue from 'vue'

const locales = {keys(){return []}}
global['____A2635A3____'] = true;
delete global['____A2635A3____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"uview-ui/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"uni-app","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"},"tabBar":{"color":"#333","selectedColor":"#27ba9b","backgroundColor":"#fff","borderStyle":"white","list":[{"text":"首页","pagePath":"pages/tabbar/index/index","iconPath":"static/tabs/home_default.png","selectedIconPath":"static/tabs/home_selected.png","redDot":false,"badge":""},{"text":"聊天","pagePath":"pages/tabbar/chat/index","iconPath":"static/tabs/category_default.png","selectedIconPath":"static/tabs/category_selected.png","redDot":false,"badge":""},{"text":"联谊","pagePath":"pages/tabbar/fellowship/index","iconPath":"static/tabs/cart_default.png","selectedIconPath":"static/tabs/cart_selected.png","redDot":false,"badge":""},{"text":"我的","pagePath":"pages/tabbar/my/index","iconPath":"static/tabs/user_default.png","selectedIconPath":"static/tabs/user_selected.png","redDot":false,"badge":""}]}};
global.__uniConfig.compilerVersion = '4.56';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__A2635A3';
global.__uniConfig.appName = 'BlindDate';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{}};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-tabbar-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/pages/tabbar/index/index"+'.vue')), 'pages-tabbar-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-tabbar-chat-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/pages/tabbar/chat/index"+'.vue')), 'pages-tabbar-chat-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-tabbar-fellowship-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/pages/tabbar/fellowship/index"+'.vue')), 'pages-tabbar-fellowship-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-tabbar-my-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/pages/tabbar/my/index"+'.vue')), 'pages-tabbar-my-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-init-init-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-init/init/index"+'.vue')), 'page-init-init-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-chat-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/chat/index"+'.vue')), 'page-jump-index-chat-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-fellowship-details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/fellowship-details/index"+'.vue')), 'page-jump-index-fellowship-details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-my-fellowship-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/my-fellowship/index"+'.vue')), 'page-jump-index-my-fellowship-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-history-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/history-order/index"+'.vue')), 'page-jump-index-history-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-userDetail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/userDetail/index"+'.vue')), 'page-jump-index-userDetail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-edit-detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/edit-detail/index"+'.vue')), 'page-jump-index-edit-detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-map-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/map/index"+'.vue')), 'page-jump-index-map-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-gold-coin-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/gold-coin/index"+'.vue')), 'page-jump-index-gold-coin-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-wxpay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/wxpay/index"+'.vue')), 'page-jump-index-wxpay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-mySocialGathering-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/mySocialGathering/index"+'.vue')), 'page-jump-index-mySocialGathering-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('page-jump-index-anti-fraud-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/weixin/uniapp-xiangqin/src/page-jump-index/anti-fraud/index"+'.vue')), 'page-jump-index-anti-fraud-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/tabbar/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white","navigationBarTitleText":"首页"})
      },
      [
        createElement('pages-tabbar-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-tabbar-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/index/index',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/tabbar/chat/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white","navigationBarTitleText":"我的消息"})
      },
      [
        createElement('pages-tabbar-chat-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-tabbar-chat-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/chat/index',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/tabbar/fellowship/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white","navigationBarTitleText":"我的联谊"})
      },
      [
        createElement('pages-tabbar-fellowship-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-tabbar-fellowship-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/fellowship/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/tabbar/my/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white","navigationBarTitleText":"个人中心"})
      },
      [
        createElement('pages-tabbar-my-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-tabbar-my-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/my/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/page-init/init/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"千里"})
      },
      [
        createElement('page-init-init-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-init-init-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-init/init/index',
  windowTop:0
}
},
{
path: '/page-jump-index/chat/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的聊天"})
      },
      [
        createElement('page-jump-index-chat-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-chat-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/chat/index',
  windowTop:0
}
},
{
path: '/page-jump-index/fellowship-details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"联谊详情"})
      },
      [
        createElement('page-jump-index-fellowship-details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-fellowship-details-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/fellowship-details/index',
  windowTop:0
}
},
{
path: '/page-jump-index/my-fellowship/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('page-jump-index-my-fellowship-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-my-fellowship-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/my-fellowship/index',
  windowTop:0
}
},
{
path: '/page-jump-index/history-order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"历史订单"})
      },
      [
        createElement('page-jump-index-history-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-history-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/history-order/index',
  windowTop:0
}
},
{
path: '/page-jump-index/userDetail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"用户详情"})
      },
      [
        createElement('page-jump-index-userDetail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-userDetail-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/userDetail/index',
  windowTop:0
}
},
{
path: '/page-jump-index/edit-detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"编辑信息"})
      },
      [
        createElement('page-jump-index-edit-detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-edit-detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/edit-detail/index',
  windowTop:0
}
},
{
path: '/page-jump-index/map/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"地图"})
      },
      [
        createElement('page-jump-index-map-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-map-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/map/index',
  windowTop:0
}
},
{
path: '/page-jump-index/gold-coin/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"充值中心"})
      },
      [
        createElement('page-jump-index-gold-coin-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-gold-coin-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/gold-coin/index',
  windowTop:0
}
},
{
path: '/page-jump-index/wxpay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"微信支付"})
      },
      [
        createElement('page-jump-index-wxpay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-wxpay-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/wxpay/index',
  windowTop:0
}
},
{
path: '/page-jump-index/mySocialGathering/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"我的联谊"})
      },
      [
        createElement('page-jump-index-mySocialGathering-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-mySocialGathering-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/mySocialGathering/index',
  windowTop:0
}
},
{
path: '/page-jump-index/anti-fraud/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"防骗指南"})
      },
      [
        createElement('page-jump-index-anti-fraud-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'page-jump-index-anti-fraud-index',
  isNVue:false,maxWidth:0,
  pagePath:'page-jump-index/anti-fraud/index',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
